/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./balance-alert.vue?vue&type=template&id=b6e92468&"
import script from "./balance-alert.vue?vue&type=script&lang=ts&"
export * from "./balance-alert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports